import React from "react";
import { Sparkles } from "lucide-react";
import { Button } from "../../../../components";

const GRADE_OPTIONS = [
  { value: "Class 1", label: "Class 1" },
  { value: "Class 2", label: "Class 2" },
  { value: "Class 3", label: "Class 3" },
  { value: "Class 4", label: "Class 4" },
  { value: "Class 5", label: "Class 5" },
  { value: "Class 6", label: "Class 6" },
  { value: "Class 7", label: "Class 7" },
  { value: "Class 8", label: "Class 8" },
  { value: "Class 9", label: "Class 9" },
  { value: "Class 10", label: "Class 10" },
  { value: "Class 11", label: "Class 11" },
  { value: "Class 12", label: "Class 12" },
];

const ClassGateModal = ({
  isOpen,
  selectedGrade,
  setSelectedGrade,
  modalLoading,
  modalError,
  onSaveGrade,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-xl space-y-6 text-center border border-slate-100">
        <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mx-auto">
          <Sparkles className="w-8 h-8 text-blue-600" />
        </div>

        <div className="space-y-2">
          <h3 className="text-xl font-black text-slate-800">Select Your Class/Grade</h3>
          <p className="text-sm text-slate-500 font-medium">
            Please tell us your current class to unlock your learning dashboard.
          </p>
        </div>

        <form onSubmit={onSaveGrade} className="space-y-4 text-left">
          <div>
            <label className="block text-xs font-bold text-slate-600 mb-1.5">
              Current Class/Grade <span className="text-red-500">*</span>
            </label>
            <select
              value={selectedGrade}
              onChange={(e) => setSelectedGrade(e.target.value)}
              className="w-full text-sm border border-slate-300 rounded-xl px-4 py-3 focus:border-blue-500 focus:ring-1 focus:ring-blue-100 outline-none transition bg-white"
              disabled={modalLoading}
            >
              <option value="">Select Class</option>
              {GRADE_OPTIONS.map((g) => (
                <option key={g.value} value={g.value}>
                  {g.label}
                </option>
              ))}
            </select>
          </div>

          {modalError && (
            <p className="text-xs text-red-500 font-semibold">{modalError}</p>
          )}

          <Button
            version="secondary"
            text={modalLoading ? "Saving..." : "Save and Continue"}
            type="submit"
            loading={modalLoading}
            className="w-full py-3 rounded-xl font-bold"
          />
        </form>
      </div>
    </div>
  );
};

export default ClassGateModal;
